import { Pipe, PipeTransform } from '@angular/core';

import * as dayjs from 'dayjs';
import * as LocalizedFormat from 'dayjs/plugin/localizedFormat';
import * as UpdateLocale from 'dayjs/plugin/updateLocale';
import * as CustomParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(LocalizedFormat);
dayjs.extend(UpdateLocale);
dayjs.extend(CustomParseFormat);

import 'dayjs/locale/hu';
import 'dayjs/locale/en';

dayjs.updateLocale('hu', {
	formats: {
		LT: 'HH:mm',
		LTS: 'HH:mm:ss',
		L: 'YYYY.MM.DD.',
		LL: 'YYYY. MMMM D.',
		LLL: 'YYYY. MMMM D. HH:mm',
		LLLL: 'YYYY. MMMM D., dddd HH:mm',
	},
});

@Pipe({ name: 'dayjsFormatDate' })
export class DayJSFormatDatePipe implements PipeTransform {
	transform(value: string, format: string = 'LL', locale?: 'hu' | 'en' | string | null): string {
		locale = locale ?? 'hu';
		return dayjs(value).locale(locale).format(format);
	}
}

@Pipe({ name: 'dayjsFormatTime' })
export class DayJSFormatTimePipe implements PipeTransform {
	transform(value: string, format: string = 'LT', locale?: 'hu' | 'en' | string | null, midnight24 = false): string {
		locale = locale ?? 'hu';
		let formattedTime = dayjs(value, ['HH:mm:ss', 'HH:mm', 'H:mm', 'H:mm:ss']).locale(locale).format(format);
		if (midnight24 && formattedTime.indexOf('00:00') === 0) formattedTime = formattedTime.replace('00:00', '24:00');
		return formattedTime;
	}
}
